module.exports = __webpack_public_path__ + "static/media/wi-sunrise.11f9daa1.svg";